import { makeApiRequest } from 'actions/api';
import { getMealBadges } from 'actions/v3/mealBadges';
import { getMealSellouts } from 'actions/v3/mealSellouts';
import { getPreviouslyOrderedMenuMeals } from 'actions/v3/previouslyOrderedMenuMeals';
import { GET_MENU_MEALS_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getFullMenuMealsData = (menuSlug, mealPlan, isOrderAgainEnabled = false) => {
  return async dispatch => {
    await dispatch(getMenuMeals(menuSlug, mealPlan));
    return Promise.all([
      dispatch(getMealBadges(menuSlug)),
      dispatch(getMealSellouts(menuSlug)),
      isOrderAgainEnabled && dispatch(getPreviouslyOrderedMenuMeals(menuSlug, mealPlan)),
    ]);
  };
};

export const getMenuMeals = (menuSlug, mealPlanSlug) =>
  makeApiRequest({
    requestType: GET_MENU_MEALS_V3,
    method: RequestService.v3.getMenuMeals,
    params: { menuSlug, mealPlanSlug },
  });
